import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { DocumentsApi } from 'api';
import { DOCUMENTS_KEY } from 'tanstack-hooks/keys';
import { getObjectMap } from 'util/objectUtils';

export function useDocuments(dispensaryId: string) {
  const documentsApi = new DocumentsApi();

  const {
    data: documents,
    isError: isErrorDocuments,
    isLoading: isLoadingDocuments
  } = useQuery({
    enabled: !!dispensaryId.length,
    queryKey: [DOCUMENTS_KEY, dispensaryId],
    queryFn: () => documentsApi.getDocuments(dispensaryId)
  });

  const { documentsMap } = useMemo(() => {
    if (!documents) return { documentsMap: {} };

    const documentsMap = getObjectMap(documents, 'id');

    return { documentsMap };
  }, [documents]);

  return { documents, documentsMap, isErrorDocuments, isLoadingDocuments };
}
